<template>
  <div id="app" :class="{ 'route-home': isHomeRoute }">
    <Navigation />
    <main class="main-content">
      <router-view />
    </main>
    <SiteFooter />
    <CookieConsent />
  </div>
</template>

<script>
import Navigation from './components/Navigation.vue'
import SiteFooter from './components/SiteFooter.vue'
import CookieConsent from './components/CookieConsent.vue'

export default {
  name: 'App',
  components: {
    Navigation,
    SiteFooter,
    CookieConsent
  },
  computed: {
    isHomeRoute() {
      return this.$route.name === 'home'
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  /* Improve text wrapping for long words */
  word-break: break-word;
  overflow-wrap: break-word;
  overflow-x: hidden;
}

.main-content {
  flex: 1;
  width: 100%;
  margin: 0 auto;
}

#app.route-home .main-content {
  max-width: none;
}

</style>